module.exports = __webpack_public_path__ + "img/football.766d6189.png";